<template>
  <div
    :class="['option-config', hasBullsEye && 'has-bullseye', hasIonChannels && 'has-ion-channels']"
    v-if="hasValues"
  >
    <div class="left-block bullseye" v-if="hasBullsEye">
      <div class="option-content bulls-eye-plot" v-if="hasBullsEye">
        <div class="section-title">Bulls-eye</div>
        <!-- {{segmentDatas}} -->
        <bullseye-diagram class="section-content"
          :selection="highlightedSegments?[highlightedSegments]:null"
          :datas="segmentDatas"
          :availableSegments="availableSegments"
          :selectable="false"
          :multiSelection="true"
          :colorScales="currentColorScales"
          @highlight="(s)=>highlightedSegments=s"
          :markedSegments="markedSegments"
          ></bullseye-diagram>
      </div>
      <div class="option-content model-container" v-if="hasBullsEye">
        <div class="section-title">3D Model</div>
        <!-- CHAPUZA DE LOS COLORSCALES... pero weno...-->
        <model-view class="section-content"
          :currentSegment="highlightedSegments"
          @highlightSegment="(s) => (highlightedSegments = s)"
          textureColor="#ddd"
          selectionColor="#dfe"
          :colorScale="currentColorScales[0]" 
          selectionOpacity="1.0"
          :segmentVariables="segmentDatas"
          :showLegend="false"
          :lazyRender="true">
        </model-view>
      </div>
    </div>
    <div class="right-block">
      <div class="general-params" v-if="hasGlobalParams && !hasIonChannels">
        <!-- <input-container
          v-for="(param, i) in globalParams"
          :key="param.name"
          v-model="globalParams[i]"
          :showTooltip="true"
        /> -->
        <population-selector-component
          v-model="globalParams"
        ></population-selector-component>
      </div>
      <div class="segment-params" v-if="hasIonChannels">
        <input-container
          v-for="(param, i) in globalParams.slice(0,4)"
          :key="param.name"
          v-model="globalParams[i]"
          :showTooltip="true"
        />
        <div class="option-content ion-channels-container">
          <div class="section-title" style="margin-left: 10px">Channels</div>
          <ion-channels class="section-content"
            :channelParams="channelParams"
            :isEditing="true"
            @modify="modifyChannelParams"
          ></ion-channels>
      </div>
      </div>
      <div class="segment-params" v-if="hasBullsEye">
        <div class="params-list">
          <segment-related-input-group v-for="(param,i) in segmentParams" :key="param.name" 
            v-model="segmentParams[i]" 
            @pick-start="onPickStart"
            @pick-end="onPickEnd"
          >
          </segment-related-input-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BullseyeDiagram from '@/components/CaseDashboard/BullseyeDiagram'
import ModelView from '@/components/CaseDashboard/3DModel'
import InputContainer from '@/components/inputs/InputContainer'
import SegmentRelatedInputGroup from '@/components/inputs/SegmentRelatedInputGroup'
import {getColorScales} from '@/utils/colorScales'
import {validateSegmentList} from '@/utils/ConfigUtils'
import {computeDomain} from '@/utils/SegmentUtils'
import IonChannels from './inputs/IonChannels'
import SubFieldListInputContainer from '@/components/inputs/SubFieldListInputContainer'
import DynamicInputGroup from '@/components/inputs/DynamicInputGroup'
import PopulationSelectorComponent from '@/components/trial/PopulationSelectorComponent'

export default {
  name: 'OptionConfig',
  components: { BullseyeDiagram, SegmentRelatedInputGroup, ModelView, InputContainer, IonChannels, SubFieldListInputContainer, DynamicInputGroup, PopulationSelectorComponent },
  props: ['optionType','values','colorScale', 'markedSegments'],
  data () {
    return {
      // option: null,
      // optionType: null,
      // values: null,
      currentSegment: null,
      highlightedSegments: null,
      channelData: null,
      plotKey: 0,
      pickingAvailableSegments: null,
    }
  },
  computed: {
    activeSegments () {
      // let segs = this.segmentParams[0].segmentList || []
      // let segs = this.segmentParams.map((d)=>d.segmentList || []).flat()
      // return segs.map((s)=>({id:s.segmentId}))
      let segs = this.segmentParams.map((d)=>d.value).flat()
      return segs
    },
    hasValues () {
      return this.values != null
    },
    hasGlobalParams () {
      return this.globalParams.length > 0
    },
    hasBullsEye () {
      return this.segmentParams.length > 0
    },
    hasIonChannels () {
      return this.channelParams.length > 0
    },
    globalParams() {
        let fields = this.values.fields || [this.values]
        let res = fields.filter(f => f.view.inputType!=="bullseye")
        res = res.filter(f => f.view.name)
        res = res.filter(f => !f.view.name.includes('IC50-') || !f.view.name.includes('H-'))
        // TODO: next line hides template Ids parameter. Pending check and fix the feature
        //if (res.length > 2 && res[1].id == 'templateIds') res.splice(1,1)
        return res
    },
    segmentParams () {
      let fields = this.values.fields || [this.values]
      let res = fields.filter(f => f.view.inputType==="bullseye").map((d)=>d.value).flat() 
      return res
    },
    segmentDatas () {
      return this.segmentParams.map((sp)=>{
        return sp.value.map((multiValue)=>{
          let firstVal = multiValue.value[1]
          let valToDisplay = firstVal.value.length>1?`[${firstVal.value.join(',')}]`:firstVal.value[0]
          let valToDraw = firstVal.view.inputType==='sliderRange' ? (firstVal.value[0]+(firstVal.value[1]-firstVal.value[0])/2) : firstVal.value[0]
          let arr = Array.isArray(multiValue.value[0].value)?multiValue.value[0].value:[multiValue.value[0].value]
          return arr.map((v,i)=>{
            return {
              id: arr[i],
              value: valToDraw
            }
          })
          
        })
      })
    },
    availableSegments() {
      // let availSegs = this.segmentParams.map((d)=>validateSegmentList(d.value[0].view.validate_items)).flat()
      return this.pickingAvailableSegments
    },
    channelParams () {
      let fields = this.values.fields || [this.values]
      let res = fields.filter(f => f.view.inputType!=="bullseye")
      res = res.filter(f => f.view.name)
      res = res.filter(f => f.view.name.includes('IC50-') || f.view.name.includes('H-'))
      if (res.length > 0) {
        let deepChannelParams = JSON.parse(JSON.stringify(res));
        this.channelData = deepChannelParams.map(channel => {
            return {channel: channel.view.name, value: channel.value[0]}
        })
      }
      return res
    },
    doseInputs() {
      let fields = this.values.fields || [this.values]
      let res = fields.filter(f => f.view.name==="Doses") //TODO: create template inputType for dynamic inputs
      return res
    },
    doseConcentrations() {
      let nonZeroDoses = []
      if(this.doseInputs.length) {
        let doses =  this.doseInputs[0].value.map((doseInput) => doseInput.value[0])
        nonZeroDoses = doses.filter(dose => dose != 0)
        nonZeroDoses.sort((a,b) => a-b)
      }
      return nonZeroDoses
    },
    currentColorScales () {
      // // let doms = []
      // // this.segmentParams.map((sp)=>{
      // //   if(sp.value[0].value[1]) {
      // //     doms.push([sp.value[0].value[1].view.validate_min[0],sp.value[0].value[1].view.validate_max[1]])
      // //   }
      // // })
      // // if(doms.length===0) doms = [[0,1]]
      // // let dom = doms.reduce((res,dom)=>{
      // //   res[0]=Math.min(res[0],dom[0])
      // //   res[1]=Math.max(res[0],dom[1])
      // //   return dom
      // // },doms[0]) 
      // let dom = computeDomain(this.segmentParams)

      // // let cs = getColorScale(this.optionType,this.values.id-1).domain(dom)
      // let cs = getColorScales(this.optionType)
      // cs.forEach((s)=>s.domain(dom))
      // //CHAPUZA: PAra que dentro de un "disease" solo haya un color
      // cs = cs.map((d,i)=>cs[0])
      // return cs
      let dom = computeDomain(this.segmentParams)

      // let cs = getColorScale(this.optionType,this.values.id-1).domain(dom)
      let cs = getColorScales(this.optionType)
      // cs.forEach((s)=>s.domain(dom))
      // //CHAPUZA: PAra que dentro de un "disease" solo haya un color
      // cs = cs.map((d,i)=>cs[0])
      let theOne = this.colorScale.copy().domain(dom)
      return cs.map((d)=>theOne)
    }

  },
  methods: {
    modifyChannelParams(value) {
      this.channelData = value
      this.plotKey += 1
    },
    // beforeOpen(event) {
    //   this.optionType = event.params.optionType
    //   this.values = event.params.values
    // },
    // beforeClose(event) {
    //   document.body.style.cursor = "default"
    // },
    // doSave(){
    //   let result = this.extractValues(this.values)
    //   console.log("should POST",result)
    //   this.$modal.hide(this.name)
    // }
    onPickStart(availableSegments){
      this.pickingAvailableSegments = availableSegments
    },
    onPickEnd(){
      this.pickingAvailableSegments = null
    }
  },
}
</script>

<style lang="stylus" scoped>
.option-config
  display: flex
  flex: 1 1 0%
  overflow auto

  &.has-bullseye
    .right-block
      flex: 0 0 60%

  .right-block
    display: flex
    flex: 1 1 0%
    flex-direction: column
    overflow-y: auto
    padding: 20px

  .left-block
    // background-color: #fff
    display: flex
    flex-direction: column
    flex: 0 0 40%
    
    .option-title
      flex: 0 0 auto

    .option-content
      display: flex
      flex: 1 1 50%
      flex-direction: column

      .section-title
        flex: 0 0 auto

      .section-content
        flex: 1 1 auto

    .bulls-eye-plot
      background: #f0f0f6
      padding: 20px

    .ion-channels-container
      background: #f0f0f6
      padding: 20px

    .model-container
      background: #ffffff
      padding: 20px

  .params-header
    display: flex
    margin-bottom: 25px
    align-items: baseline
    .modal-actions
      margin-left: auto
      max-height 32px

  .option-title
    m-font-size(28, 32)
    font-weight: $fw-light
    overflow-wrap: anywhere

  .section-title
    m-font-size(16, 18)
    color: $gull-gray
    font-weight: $fw-light
    text-transform: uppercase
</style>